import { WA_BLACK, WA_TRANSPARANT } from '@constants';
import * as utils from '@utils/form';
import { IMAGE_SIZE } from '@api/media/constants';

export const FORM_FIELD = {
  TITLE: {
    name: 'title',
    label: 'Title:',
    placeholder: 'Enter a title',
  },
  CONTENT: {
    name: 'content',
    label: 'Add HTML:',
    rules: [{ required: true, message: 'HTML is required' }],
  },
  URL: {
    name: 'url',
    label: 'URL:',
    placeholder: 'Enter the page URL',
    rules: [{ type: 'url', message: "Doesn't look like a valid URL" }],
  },
  URL_TEXT: {
    name: 'urlText',
    label: 'URL Text:',
    placeholder: 'Enter the text URL redirecting to URL',
  },
  BACKGROUND: {
    name: 'backgroundImage',
    label: 'Background image:',
    buttonText: 'CHOOSE A NEW IMAGE',
    rules: [{ required: true, message: 'Background image is required' }],
    size: IMAGE_SIZE['1440x300'],
    serialize: utils.imageSerialize,
    deserialize: utils.imageDeserialize,
    deserializeError: utils.deserializeErrorRelatedField,
  },
  BACKGROUND_COLOUR: {
    name: 'backgroundColour',
    label: 'Background colour:',
    colors: [WA_BLACK, WA_TRANSPARANT],
    rules: [{ required: true, message: 'Background colour is required' }],
  },
};

export const FORM_FIELDS = Object.values(FORM_FIELD);
